// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__1sQph"};